import { render, staticRenderFns } from "./Bando29Fase6.vue?vue&type=template&id=14c4036d&scoped=true"
import script from "./Bando29Fase6.vue?vue&type=script&lang=js"
export * from "./Bando29Fase6.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c4036d",
  null
  
)

export default component.exports